import { useEffect, useState } from 'react';
import "../style/AgeConfirmation.css";
import { useTranslation } from 'react-i18next';

const CenteredOverlay = () => {
  const { t } = useTranslation();

  const [isConfirmed, setIsConfirmed] = useState(() => {
    const ageConfirmedTime = localStorage.getItem('ageConfirmedTime');
    
    if (ageConfirmedTime) {
      const timeDifference = Date.now() - parseInt(ageConfirmedTime, 10);
      
      // If more than 31 days have passed, reset age confirmation
      if (timeDifference > 31 * 24 * 60 * 60 * 1000) {
        localStorage.removeItem('ageConfirmed');
        localStorage.removeItem('ageConfirmedTime');
        return false;
      }
      
      // If still valid, check if confirmed
      if (localStorage.getItem('ageConfirmed') === 'true') {
        return true;
      }
    }
    return false;
  });

  // Once confirmed, allow scrolling again
  useEffect(() => {
    if (isConfirmed) {
      document.body.style.overflow = 'auto'; // Enable scrolling
    } else {
      document.body.style.overflow = 'hidden'; // Disable scrolling
    }
  }, [isConfirmed]);

  // Handle the confirm action
  const handleConfirm = () => {
    localStorage.setItem('ageConfirmed', 'true');
    localStorage.setItem('ageConfirmedTime', Date.now().toString());
    setIsConfirmed(true);
  };

  // Handle the deny action
  const handleDeny = () => {
    window.location.href = 'about:blank';
  };

  // If confirmed, return nothing
  if (isConfirmed) return null;
    return (
      <div className={`centered-overlay`}>
        <div className="spinner">
          <div className="age-confirmation-overlay">
            <div className="age-confirmation-modal">
              <p className="smaller-title-modal">{t("ageConfirmation.ageConfirmationTitle")}</p>
              <h3>{t("ageConfirmation.ageConfirmationText")}</h3>
              <div className="age-confirmation-buttons">
                <button className="form-button full-width" onClick={handleConfirm}>{t("ageConfirmation.confirmButtonLabel")}</button>
                <button className="form-button full-width" onClick={handleDeny}>{t("ageConfirmation.cancelButtonLabel")}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

export default CenteredOverlay;
